export const schoolCodesSelector = (state: any) => state.schoolCodes;
